import {
  resetStateToDefault,
  vuexMapDefaultsMutations,
  vuexMapDefaultsActions,
  vuexMapDefaultsGetters
} from 'src/utils'

import { API } from 'src/services'

const ddds = [
  '11', '12', '13', '14',
  '15', '16', '17', '18',
  '19', '21', '22', '24',
  '27', '28', '31', '32',
  '33', '34', '35', '37',
  '38', '41', '42', '43',
  '44', '45', '46', '47',
  '48', '49', '51', '53',
  '54', '55', '61', '62',
  '63', '64', '65', '66',
  '67', '68', '69', '71',
  '73', '74', '75', '77',
  '79', '81', '82', '83',
  '84', '85', '86', '87',
  '88', '89', '91', '92',
  '93', '94', '95', '96',
  '97', '98', '99'
]

function fromBackend (company) {
  // returns a object that we can use in Object.assign to update all state once

  const formatPhone = number => {
    const isVoip = !(/55[0-9]{10,11}/.test(number))
    return {
      number: isVoip ? number : number.slice(2),
      voip: isVoip,
      editing: false
    }
  }
  return {
    id: company.id,
    code: company.code,
    name: company.name,
    // dateModified: company.dateModified,
    // phonePrefix: company.phonePrefix,
    phone: company.phone.map(formatPhone),
    appearOnRealtime: company.appearOnRealtime,
    ddd: company.ddd,
    active: company.active,
    region: company.region,
    fullRegion: company.fullRegion,
    // routine: company.routine,
    priority: company.priority,
    color: company.color,
    customRules: company.customRules,
    location: company.location,
    // repList: company.repList,
    hasOnCall: company.hasOnCall,
    supervisor: company.supervisor,
    positions: company.positions,
    reserve: company.reserve
    // approveOverridePermission: company.approveOverridePermission
  }
}

function toBackEnd (state) {
  const formatPhone = ({number, voip}) => {
    const numWithoutMask = number
      .replace('(', '')
      .replace(')', '')
      .replace('-', '')

    if (voip) {
      return numWithoutMask
    }
    return `55${numWithoutMask}`
  }

  return {
    id: state.id,
    code: state.code,
    name: state.name,
    // dateModified: state.dateModified,
    phonePrefix: state.phonePrefix,
    phone: state.phone.map(formatPhone),
    appearOnRealtime: state.appearOnRealtime,
    ddd: state.ddd.selected.id,
    active: state.active,
    region: state.fullRegion[state.fullRegion.length - 1].id,
    routine: state.routine,
    priority: state.priority,
    color: state.color,
    customRules: state.customRules.selected?.id,
    location: state.location,
    repList: state.repList,
    hasOnCall: state.hasOnCall,
    supervisor: state.supervisor.selected?.id,
    positions: state.positions,
    reserve: state.reserve,
    approveOverridePermission: state.approveOverridePermission
  }
}

function defaultState () {
  return {
    id: null,
    loading: false,
    code: null,
    name: '',
    // dateModified: null,
    // phonePrefix: null,
    phone: [],
    appearOnRealtime: true,
    ddd: {
      selected: {id: '11', name: '11'},
      loaded: ddds.map(ddd => { return {id: ddd, name: ddd} })
    },
    active: true,
    region: null,
    fullRegion: [],
    // routine: null,
    priority: 1,
    color: '#f6',
    customRules: { selected: null },
    location: [],
    // repList: null,
    hasOnCall: false,
    supervisor: { selected: null },
    positions: [],
    reserve: false
    // approveOverridePermission: null
  }
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState())
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  setFromState (state, {commonSupervisors, commonCustomRules, ...company}) {
    state.ddd.selected = {id: company.ddd, name: company.ddd}
    state.customRules.selected = commonCustomRules.find(r => r.id === company.customRules)
    state.supervisor.selected = commonSupervisors.find(s => s.id === company.supervisor)

    delete company.ddd
    delete company.customRules
    delete company.supervisor
    Object.assign(state, company)
  },
  loading (state, payload) {
    state.loading = payload
  }
}

const actions = {
  ...vuexMapDefaultsActions(defaultState()),
  async loadCompany ({ commit, rootState }, companyId) {
    commit('loading', true)

    const api = await API.company.get({id: companyId})

    commit('setFromState', {
      id: companyId,
      commonSupervisors: rootState.common.supervisors.items,
      commonCustomRules: rootState.common.customRules.items,
      ...fromBackend(api.data.success[0])
    })

    commit('loading', false)
  },
  async save ({ state }) {
    const info = toBackEnd(state)

    if (state.id) {
      await API.company.save({id: state.id}, info)
    } else {
      await API.company.save(info)
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
